export default __webpack_public_path__ + "static/media/avatar_1@3x.abeaf3c8.png";